import { Box, Typography } from "@mui/material";
import AdxStatusBar from "components/reusable/statusBar/AdxStatusBar";
import React from "react";

export const OvertimeList = ({ details, sx }) => {
  const { rate, title } = details;
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      padding={2}
      sx={{ ...sx }}
    >
      <Box
        display="flex"
        alignItems="center"
        sx={{ width: "calc(100% * 1 / 3)", mr: 2 }}
      >
        <Typography noWrap variant="subtitle1" mr={2}>
          {title}
        </Typography>
        {details.default === 0 && (
          <AdxStatusBar status={{
            text: 'Default',
            bgColor: 'gray-background.main',
            color: 'light-gray-text.main'
          }} />
        )}
      </Box>
      <Box sx={{ width: "calc(100% * 2 / 3)" }}>
        <Typography color="light-gray-text.main">{`Rate: ${rate} times of salary`}</Typography>
      </Box>
    </Box>
  );
};
